import { createContext, useContext, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Body from "./pages/body/Body";
import TopSignal from "./pages/trade signal/TopSignal";
import LastSignal from "./pages/last signal/LastSignal";
import CreateSignal from "./pages/create signal/CreateSignal";
import MainLayout from "./pages/main layout/MainLayOut";
import "./App.css";
import Login from "./pages/login/Login";
import Toast from "./utiles/Toast";
import { useSelector } from "react-redux";
import Profile from "./pages/profile/Profile";
import AllNews from "./pages/news/AllNews";
import NewsDetail from "./pages/news/DetailNews/DetailsNews";
import AboutPage from "./pages/about/About";
import TradeSignalPage from "./pages/about/about_en/About_en";
import SignalPage from "./pages/signal/Signal";
import SignalDetails from "./pages/signal/SignalDetails";
import PackageDetails from "./pages/signal/PackageDetails";
import Invites from "./pages/login/components/Invites";
import MySignals from "./pages/my signals/MySignals";
import StartPage from "./pages/start app/Start";
import { useIsStandalone } from "./utiles/isStandalone";
import InviteSheet from "./pages/profile/pages/invite/Invite";
import Support from "./pages/profile/pages/support/support";
import Wallet from "./pages/profile/pages/wallet/wallet";
import Commission from "./pages/profile/pages/commission/commission";
import Renew from "./pages/profile/pages/renew/renew";
import BanHistory from "./pages/profile/pages/banHistory/banHistory";
import { selectUser, selectIsBanned } from "./redux/slices/userSlice";
import FinancialReport from "./pages/profile/pages/FinancialReports/FinancialReports";
import ScrollToTop from "./utiles/ScrollTo";
import CompleteProfile from "./pages/profile/pages/completeProfile/completeProfile";
import ProfileFunction from "./functions/profileFunction/ProfileFunction";
import PrivacyPolicy from "./pages/profile/pages/privacyPolicy/PrivacyPolicy";
import TopTradersPage from "./pages/trade signal/TopTradersPage";
import LoadingForLogin from "./pages/loading/loading";

export const SafeAreaContext = createContext();

export const SafeAreaProvider = ({ children }) => {
  const [safeAreaColor, setSafeAreaColor] = useState({ background: "#ffffff" });

  useEffect(() => {
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute(
        "content",
        safeAreaColor.background.includes("linear-gradient")
          ? // "#6366f1"
            "ffffff"
          : safeAreaColor.background,
      );
    }
  }, [safeAreaColor]);

  return (
    <SafeAreaContext.Provider value={{ safeAreaColor, setSafeAreaColor }}>
      {children}
    </SafeAreaContext.Provider>
  );
};

const SafeArea = () => {
  const { safeAreaColor } = useContext(SafeAreaContext);
  return (
    <>
      <div className="safe-area-top" style={safeAreaColor} />
      <div className="safe-area-bottom" style={safeAreaColor} />
    </>
  );
};

const AppContent = () => {
  const location = useLocation();
  const isLoggedIn = useSelector((state) => state.login.token);
  const isStandalone = useIsStandalone();
  const isSafari = isSafariByUA();

  // if (isLoggedIn) {
  //   ProfileFunction();
  // }

  /////////////////////////////////////////////////

  const userData = useSelector(selectUser);
  const isBanned = useSelector(selectIsBanned);
  /////////////////////////////////////////////////

  if (isBanned === true && isBanned !== undefined) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-red-100 via-red-50 to-red-100 overflow-hidden">
        <div className="relative font-bold text-center p-6 sm:p-10 bg-white rounded-3xl shadow-2xl w-full max-w-xs sm:max-w-sm animate-fadeIn">
          {/* Alert icon */}
          <div className="mx-auto w-20 h-20 sm:w-24 sm:h-24 flex items-center justify-center bg-red-100 rounded-full mb-6 animate-pulse">
            <span className="font-bold text-5xl sm:font-bold text-red-600">
              🚫
            </span>
          </div>

          {/* Title */}
          <h2 className=" text-2xl sm:text-3xl font-extrabold text-red-700 mb-4 tracking-tight">
            Account Suspended
          </h2>

          {/* Description */}
          <p className="font-bold text-gray-700 mb-4 text-sm sm:text-base">
            Your account has been suspended due to security reasons or violation
            of site policies.
          </p>

          <p className="font-bold text-gray-500 text-xs sm:text-sm mb-6">
            For more information, please contact support.
          </p>

          {/* Contact support button */}
          <div className="flex justify-center">
            <button className="bg-red-600 hover:bg-red-700 text-white font-medium py-3 px-8 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg w-full sm:w-auto">
              Contact Support
            </button>
          </div>

          {/* افکت های پس‌زمینه */}
          <div className="absolute -top-16 -left-16 w-32 h-32 bg-red-200 rounded-full opacity-50 blur-3xl animate-blob"></div>
          <div className="absolute -bottom-16 -right-16 w-40 h-40 bg-red-300 rounded-full opacity-40 blur-3xl animate-blob animation-delay-2000"></div>
        </div>
      </div>
    );
  }

  if (isSafari && !isStandalone) {
    return <StartPage />;
  }

  return (
    <AnimatePresence mode="wait">
      <Toast key="toast"></Toast>

      <Routes location={location} key={location.pathname}>
        {isLoggedIn ? (
          <>
            <Route element={<MainLayout />}>
              <Route path="/" element={<Body />} />
              <Route path="/topSignals" element={<TopSignal />} />
              <Route path="/lastSignals" element={<LastSignal />} />
              <Route path="/profile" element={<Profile />}></Route>
              <Route path="/completeProfile" element={<CompleteProfile />}></Route>
              <Route path="/news" element={<AllNews />}></Route>
              <Route path="/newsDetail/:id" element={<NewsDetail />}></Route>
              <Route path="/signal" element={<SignalPage />}></Route>
              <Route path="/financial-report" element={<FinancialReport />} />
              <Route path="/top-traders" element={<TopTradersPage />}></Route>
              <Route path="/invite" element={<InviteSheet />}></Route>
              <Route path="/support" element={<Support />}></Route>
              <Route path="/ban-history" element={<BanHistory />}></Route>
              <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
              <Route path="/*" element={<Body />}></Route>
            </Route>

            <Route path="/signal/:id" element={<SignalDetails />} />
            <Route path="/signal/package/:id" element={<PackageDetails />} />
            <Route path="/createSignal" element={<CreateSignal />} />
            {/* <Route path="/startpage" element={<StartPage />} /> */}
            <Route path="/mysignals" element={<MySignals />} />
            <Route path="/about" element={<AboutPage />}></Route>
            <Route path="/about-en" element={<TradeSignalPage />}></Route>

            <Route path="/wallet" element={<Wallet />}></Route>
            <Route path="/commission" element={<Commission />}></Route>
            <Route path="/renew" element={<Renew />}></Route>
          </>
        ) : (
          <>
            <Route element={<Login></Login>} path="/login"></Route>
            <Route element={<Login></Login>} path="*"></Route>
            <Route element={<LoadingForLogin/>} path="loading"></Route>
          </>
        )}

        <Route path="/invites" element={<Invites />} />
        <Route path="/login" element={<Login />}></Route>
      </Routes>
    </AnimatePresence>
  );
};

function isSafariByUA() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent.toLowerCase();
  return (
    ua.includes("safari") &&
    !ua.includes("crios") &&
    !ua.includes("fxios") &&
    !ua.includes("edg") &&
    !ua.includes("chrome")
  );
}

function App() {
  return (
    <SafeAreaProvider>
      <SafeArea />
      <Router>
        <ScrollToTop />

        <AppContent />
      </Router>
    </SafeAreaProvider>
  );
}

export default App;
